/*
 * @Author: xinxin 18617269361@163.com
 * @Date: 2025-06-05 17:18:20
 * @LastEditors: xinxin 18617269361@163.com
 * @LastEditTime: 2025-06-16 18:37:51
 * @FilePath: \lhao-pc\src\request\request.js
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
// 全局安装axios并引用
import axios from "axios";
// 创建axios实例
const instance = axios.create({
  // baseURL: "http://192.168.0.54:8087", // API基础路径 lhaob.com
  baseURL: "https://proxy.lhaob.com/", // API基础路径
  timeout: 30000, // 请求超时时间
});
// 请求拦截器
instance.interceptors.request.use(
  (config) => {
    // 在发送请求之前做些什么
    // 从localStorage或sessionStorage中获取token
    const token = localStorage.getItem("token");
    if (token) {
      // 如果token存在，则添加到请求头中
      config.headers["Authorization"] = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// 响应拦截器
instance.interceptors.response.use(
  (response) => {
    // 对响应数据做点什么
    if (response && response.data.code == 401) {
    }
    return response.data;
  },
  (error) => {
    // 处理响应错误

    return Promise.reject(error);
  }
);

export default instance;
